module.exports = __webpack_public_path__ + "img/en2.05d5404c.webp";